module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staff-boxs"
  }, [_c('div', {
    staticClass: "top-bar com-model m-b-24"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/finance'
      }
    }
  }, [_vm._v("财务管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("设置支付密码")])], 1)], 1), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "staffmanage"
  }, [_c('div', {
    staticClass: "st-change-item st-change-item1",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "tit titrequire",
    attrs: {
      "placeholder": "请输入密码"
    }
  }, [_vm._v("新密码")]), _vm._v(" "), _c('input', {
    staticClass: "inp",
    attrs: {
      "type": "password"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "st-change-item st-change-item1"
  }, [_c('div', {
    staticClass: "tit titrequire"
  }, [_vm._v("再次输入")]), _vm._v(" "), _c('input', {
    staticClass: "inp",
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "stepbtn"
  }, [_vm._v("完成")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58a96351","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/setPayPassword.vue
// module id = 881
// module chunks = 1